import { motion } from "framer-motion";

const lineVariants = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: 0,
    transition: { delay: 0.15 + i * 0.12, duration: 0.9, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const MaskedLines = ({ lines, className = "", as = "h1", ...rest }) => {
  const Tag = motion[as] || motion.h1;
  return (
    <Tag
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      {...rest}
    >
      {lines.map((line, i) => (
        <span key={i} className="mask-reveal-line">
          <motion.span className="block" custom={i} variants={lineVariants}>
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeIn = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ delay, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ number, title, accent }) => (
  <div className="mb-16 md:mb-24">
    <FadeIn className="mb-4 flex items-center gap-4">
      <span className="font-mono text-sm text-[#FF5E36]">/{number}</span>
      <span className="h-px w-16 bg-[#4A5568]" />
      <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#4A5568]">{accent}</span>
    </FadeIn>
    <MaskedLines
      lines={[title]}
      as="h2"
      className="font-display text-4xl font-extrabold leading-none tracking-tight text-[#FDFBF7] sm:text-5xl lg:text-7xl"
    />
  </div>
);
